import React, { useState, useRef, useEffect } from "react";
import Header from "../component/Header";
import HomeTable from "../component/HomeTable";
import middleImage from "../image/thumbnail_BANNER copy.png";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import useLoader from "../Hooks/useLoader";
import SnackBar from "../component/SnackBar";
import axios from "axios";
import { getMSID, getToken } from "../common";


const HomePage = () => {
  const [showTable, setShowTable] = useState(false);
  const [data, setData] = useState([]);
  const [loader, showLoader, hideLoader] = useLoader();
  const alertRef = useRef();

  const apiCallDummy = async () => {
    try {
      const token = getToken();
      // console.log("token",JSON.stringify(token))

      const header = {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
      showLoader();
      const response = await axios.get(
        process.env.REACT_APP_API_URI + "get_short_summary",
        header
      );
      if (response.status === 200) {
        setShowTable(true);
        if(response.data!=="No data found"){
          setData(response.data);
          hideLoader();
        }
      else if(response.data==="No data found"){
         setData({});
          hideLoader();
      }

      }
      // setData(response);
    } catch (error) {
      alertRef.current.showSnackbar();
      hideLoader();
    }
  };

  useEffect(() => {
    apiCallDummy();
  }, []);

  return (
    <div className="container">
      {/* Header Section */}
      <Header />

      {/* Middle Section */}
      <main className="middle">
        <img src={middleImage} alt="image" className="imageStyle" />
      </main>

      {/* Lower Section */}
      <section className="lower">
        <div className="summaryTable">Summary Table</div>
        {/*<div className="summaryTableBelow">Find the recent processed data</div>*/}
        <div className="tablem">
          {loader}
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <HomeTable 
localization={{
    actions: 'Column Filters', // ✅ This changes the tooltip text
  }}
 data={data} tableValue={showTable} />
          </LocalizationProvider>
        </div>
      </section>
      <SnackBar ref={alertRef} />
    </div>
  );
};

export default HomePage;
